import { useCallback, useEffect, useState } from "react";
import { Constants, Enums } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../hooks";
import APIs from "../../apis";

const useViewModel = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { execute } = useApi();

  useEffect(() => {
    getServices();
  }, []);

  const getServices = useCallback(async () => {
    const data = await execute(APIs.subscriptions.subscriptions, {
      setLoading,
    });
    setSubscriptions(
      data.map((_) => ({
        ..._.configuration.device,
        uuid: _.id,
        state: _.state,
        deleted: _.deleted,
        paymentInfo: _.paymentInfo,
      }))
    );
  }, []);

  return {
    loading,
    subscriptions,
    onClickSubscription: (uuid) =>
      navigate(`${Enums.pagesNames.subscription}/${uuid}`),
    onClickPurchase: () => navigate(Enums.pagesNames.purchaseSubscription),
    onLearnMore: () =>
      window.open(Constants.Project.urls.alarmServices, "_blank"),
  };
};

export default useViewModel;
